import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const GarageDoor = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my garage door business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps garage door businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for garage door businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most garage door businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my garage door business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like garage door. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Garage Door - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Garage Door CRM", url: "/industries/garage-door" }
  ];

  const industryData = {
    name: 'Garage Door Repair',
    title: 'Capture Emergency Repair Calls & Build Preventive Maintenance Revenue',
    subtitle: 'Never miss urgent broken spring calls, automate maintenance reminders, and convert repairs to new door sales',
    icon: '🚪',
    challenges: [
      'Missing emergency repair calls',
      'One-time customers never return',
      'Hard to convert repairs to new sales',
      'Difficult to schedule efficiently',
      'Parts inventory management'
    ],
    solutions: [
      'Emergency call routing 24/7',
      'Automated annual maintenance reminders',
      'New door replacement nurture campaigns',
      'Geographic scheduling optimization',
      'Parts tracking and ordering'
    ],
    features: [
      'Emergency call capture',
      'Automated maintenance reminders',
      'Repair to replacement campaigns',
      'Route-based scheduling',
      'Parts inventory tracking',
      'Photo documentation',
      'Warranty tracking',
      'Review automation'
    ],
    results: [
      'Never miss emergency calls',
      '55% convert to annual maintenance',
      '30% repairs lead to new door sales',
      '£6.1K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Garage Door UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for garage door businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for garage door UK, garage door business software, garage door customer management, garage door lead generation UK"
        url="/industries/garage-door"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default GarageDoor;